export const CANADIAN_BASE_INSERTION_FEE = 0.30;
export const US_BASE_INSERTION_FEE = 0.35;

// International sales fee calculation
export const calculateInternationalFee = (overseasSales: string, totalSaleAmount: number): number => {
  // 1.65% of total sale amount for international sales (unless using eBay International Shipping)
  if (overseasSales === 'Yes' || overseasSales === 'Other') {
    return totalSaleAmount * 0.0165;
  }
  return 0;
};

// Seller level fee adjustments
export const calculateSellerLevelAdjustment = (sellerLevel: string, finalValueFee: number): number => {
  // Below Standard sellers pay an additional 6% on final value fees
  if (sellerLevel === 'Below Standard') {
    return finalValueFee * 0.06;
  }
  return 0;
};

export const EBAY_STORE_TYPES = {
  US: [
    "Basic",
    "Anchor",
    "Premium",
    "Starter",
    "Enterprise",
    "None"
  ],
  CA: [
    "Basic",
    "Anchor",
    "Premium",
    "None"
  ]
};
  
export const EBAY_SELLER_LEVELS = [
  "Top Rated",
  "Above Standard",
  "Below Standard",
];
  
export const OVERSEAS_SALES = {
  US: ["No", "Yes"],
  CA: ["Domestic", "USA", "Other"],
};

export const FEE_STRUCTURES = {
  US: {
    "All other categories": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.136
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Books & Magazines": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.153
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Movies & TV": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.153
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Music": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.153
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Coins & Paper Money": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1325
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Bullion": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.136
        } else {
          return salePrice * 0.07
        }
      },
    },
    "Women's Bags & Handbags": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 2000) {
          return salePrice * 0.15
        } else {
          return salePrice * 0.09
        }
      },
    },
    "Collectibles": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1325
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Jewelry": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 5000) {
          return salePrice * 0.15
        } else {
          return salePrice * 0.09
        }
      },
    },
    "Watches, Parts & Accessories": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 1000) {
          return salePrice * 0.15
        } else if (salePrice <= 7500) {
          return salePrice * 0.065
        } else {
          return salePrice * 0.03
        }
      },
    },
    "NFT Categories": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => salePrice * 0.05,
    },
    "Business & Industrial": {
      insertionFee: 20,
      finalValueFee: (salePrice) => {
        if (salePrice <= 15000) {
          return salePrice * 0.03
        } else {
          return salePrice * 0.005
        }
      },
    },
    "Guitars & Basses": {
      insertionFee: 0,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.067
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Athletic Shoes": {
      insertionFee: US_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice >= 150) {
          return salePrice * 0.08
        } else {
          return salePrice * 0.136
        }
      },
    },
  },
  CA: {
    "All other categories": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1395
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Books & Magazines": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1495
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Movies & TV": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1495
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Music": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1495
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Coins & Paper Money": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1395
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Bullion": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1395
        } else {
          return salePrice * 0.07
        }
      },
    },
    "Women's Bags & Handbags": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 2000) {
          return salePrice * 0.15
        } else {
          return salePrice * 0.09
        }
      },
    },
    "Collectibles": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.1395
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Jewelry": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 5000) {
          return salePrice * 0.15
        } else {
          return salePrice * 0.09
        }
      },
    },
    "Watches, Parts & Accessories": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice <= 1000) {
          return salePrice * 0.15
        } else if (salePrice <= 7500) {
          return salePrice * 0.065
        } else {
          return salePrice * 0.03
        }
      },
    },
    "NFT Categories": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => salePrice * 0.05,
    },
    "Business & Industrial": {
      insertionFee: 20,
      finalValueFee: (salePrice) => {
        if (salePrice <= 15000) {
          return salePrice * 0.03
        } else {
          return salePrice * 0.005
        }
      },
    },
    "Guitars & Basses": {
      insertionFee: 0,
      finalValueFee: (salePrice) => {
        if (salePrice <= 7500) {
          return salePrice * 0.067
        } else {
          return salePrice * 0.0235
        }
      },
    },
    "Athletic Shoes": {
      insertionFee: CANADIAN_BASE_INSERTION_FEE,
      finalValueFee: (salePrice) => {
        if (salePrice >= 150) {
          return salePrice * 0.08
        } else {
          return salePrice * 0.1395
        }
      },
    },
  },
};